import fetchDistributors from 'api/fetchDistributors';
import fetchGroups from 'api/fetchGroups';
import fetchManufactures from 'api/fetchManufactures';
import fetchRepresentatives from 'api/fetchRepresentative';
import fetchRole from 'api/fetchRole';
import fetchTeams from 'api/fetchTeams';
import fetchTerritory from 'api/fetchTerritory';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setManufactures,
  setDistributors,
  setTerritory,
  setRoles,
  setRepresentative,
  setGroups,
  setTeams
} from 'redux/modules/app/slice';
import { getApp, getFilter, getUser } from 'selectors';
import isEmptyArray from 'utils/isEmptyArray';
import isEmptyObject from 'utils/isEmptyObject';

const useApp = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(getUser);
  const appState = useSelector(getApp);

  const filter = useSelector(getFilter);

  useEffect(() => {
    if (currentUser && !isEmptyObject(currentUser)) {
      fetchManufactures().then((result) => {
        if (result) {
          dispatch(setManufactures(result));
        }
      });
      fetchDistributors().then((result) => {
        if (result) {
          dispatch(setDistributors(result));
        }
      });
      fetchTerritory().then((result) => {
        if (result) {
          dispatch(setTerritory(result));
        }
      });
      fetchRole().then((result) => {
        if (result) {
          console.log(`fetchRoles`, result);
          dispatch(setRoles(result));
        }
      });
      fetchRepresentatives().then((result) => {
        if (result) {
          console.log(`fetchRepresentatives`, result);
          dispatch(setRepresentative(result));
        }
      });
      fetchGroups().then((result) => {
        if (result) {
          console.log(`fetchGroups`, result);
          dispatch(setGroups(result));
        }
      });
      fetchTeams().then((result) => {
        if (result) {
          console.log(`fetchTeams`, result);
          dispatch(setTeams(result));
        }
      });
    }
  }, [currentUser]);

  return appState;
};

export default useApp;
